import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import QrReader from 'react-qr-reader';
import querySearch from "stringquery";
import {apiPost, apiRequest} from '../../utils/request';
import {
  Aux,
  BASE_URL,
  IsInRole, isNullEmptyOrWhitespace,
  IsNullOrUndefined,
  KG_L_CONVERSION,
  LONG_DATE_FORMAT,
  SHORT_DATE_FORMAT,
  allowUserWithRoles,
  ROLE_SuperUser,
  ROLE_OfficeUser, ROLE_SalesManager
} from "../../constants";
import moment from "moment";
import {push} from "../../utils/navigation";
import {toastr} from 'react-redux-toastr';
import {loadRun} from "../../actions/runActions";
import ScaleStatusView from "../Scales/ScaleStatusView";
import {flatten} from "lodash-es";
import { withRouter } from '../../utils/withRouter';

/*

Need a better way to track the state, screen can be in the following stages:

* Linked from a run (has runid, pickupid and pickuptankid
* weightScalePickup in progress
* Allow scan for tank info
* Tank not found
* Tank found with associated run
* Tank found no associated run
* Begin weight scale pickup
* End weight scale pickup
* Allow scan for end weight scale
* Navigate on finish

 */

const STATE_CAN_BEGIN_SCAN = 0;
const STATE_WEIGHT_CAN_BEGIN_FROM_REF = 1; // scan has happened, have tank info and it matches the URL
const STATE_WEIGHT_CAN_BEGIN_POTENTIAL = 2; // scan has happened, have tank info and it matches the URL
const STATE_WEIGHT_IN_PROGRESS = 3;
const STATE_WEIGHT_ENDING = 4;
const STATE_WEIGHT_ENDED = 5;
const STATE_WEIGHT_ENDING_WRONG_TANK = 6;
const STATE_WEIGHT_CANCELLING_NEED_REASON = 7;
const STATE_WEIGHT_CANCELLING = 8;
const NO_WEIGHT_SHOWING_TANK_INFO = 9;


const defaultLookupParams = {
  runId: null,
  pickupId: null,
  action: null,
  pickupTankId: null,
};

class QrLookupRunLocationPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      scanResult: null,
      canScan: true,
      status: null,
      tankInfo: null,
      autoNavigateToRun: !props.weightScales.connected,
      lookupParams: props.lookupParams ? props.lookupParams : {...defaultLookupParams},
      currentWeightScalePickup: null,      
      weightScalesPickup: null,
      overallState: STATE_CAN_BEGIN_SCAN,
    };

    this.onError = this.onError.bind(this);
    this.onScan = this.onScan.bind(this);
    this.getTankInfo = this.getTankInfo.bind(this);
    this.onTankInfoReceived = this.onTankInfoReceived.bind(this);
    this.handleAddPickup = this.handleAddPickup.bind(this);
    this.getRunUrl = this.getRunUrl.bind(this);
    this.getLatestPickupWeight = this.getLatestPickupWeight.bind(this);
    this.startPickupWeight = this.startPickupWeight.bind(this);
    this.endPickupWeight = this.endPickupWeight.bind(this);
    this.beginEndPickupWeight = this.beginEndPickupWeight.bind(this);
    this.beginCancel = this.beginCancel.bind(this);
    this.completeCancel = this.completeCancel.bind(this);
    this.getNetLitres = this.getNetLitres.bind(this);
    /*
    
    Look-up tank weights if existing pickup in progress, if one exists, stop them scanning
    If not, scan and display a begin Pickup
    
    
      Page to scan
      Button to reset
      Given a QR code
      Trim tankId
      Exchange TankId for RunId & LocationId from service
      Load the runId
      Button to navigate to pickup
      http://localhost:3000/runplanner-web-ui/runs/search/12229/locations/6435
    */
  }

  onScan(data) {
    if (data && this.state.canScan) {
      console.log(data);
      if (data.includes('?')) {
        let split = data.split('?');
        let query = querySearch(`?${split[1]}`);
        this.setState({scanResult: data, canScan: false, status: `Looking up tank Id: ${query.tankId}`}, () => {
          this.getTankInfo(query.tankId);
        });
      } else {
        this.setState({scanResult: data, canScan: true, status: 'Scan does not contain a tankId'});
      }
    }
  }

  onTankInfoReceived() {
    let {autoNavigateToRun, tankInfo, lookupParams, currentWeightScalePickup, overallState} = this.state;
    let {weightScales} = this.props;

    if(overallState === STATE_WEIGHT_ENDING && !IsNullOrUndefined(tankInfo)){
      if(currentWeightScalePickup.tankId === tankInfo.id){
       this.endPickupWeight(); 
      } else {
        this.setState({overallState: STATE_WEIGHT_ENDING_WRONG_TANK});
      }
    } else if (!IsNullOrUndefined(tankInfo) && !tankInfo.isInactive
        && weightScales.connected
        && lookupParams.runId
        && tankInfo.runs && tankInfo.runs.length > 0 && tankInfo.runs.findIndex(r => r.id === parseInt(lookupParams.runId)) >= 0) {
      let run = tankInfo.runs.find(r => r.id === parseInt(lookupParams.runId));
      this.setState({
        overallState: overallState === STATE_WEIGHT_IN_PROGRESS ? STATE_WEIGHT_IN_PROGRESS : STATE_WEIGHT_CAN_BEGIN_FROM_REF,
        weightScalesPickup: {
          pickupTankId: run.pickupTankId,
        }
      });
    } else if (!IsNullOrUndefined(tankInfo) && !tankInfo.isInactive
        && weightScales.connected
        && tankInfo.potentialDriverRuns && tankInfo.potentialDriverRuns.length) {
      this.setState({
        overallState: STATE_WEIGHT_CAN_BEGIN_POTENTIAL,
        weightScalesPickup: null
      });
    } else if (autoNavigateToRun && tankInfo && tankInfo.runs && tankInfo.runs.length > 0 && !tankInfo.isInactive) {
      if (lookupParams.runId) {
        if (tankInfo.runs.findIndex(r => r.id === parseInt(lookupParams.runId)) >= 0) {
          this.props.dispatch(push(`${BASE_URL}/runs/${this.getRunUrl(lookupParams.runId)}/locations/${tankInfo.currentTankLocationId}/${tankInfo.id}`));
        } else {
          toastr.error(`This tank does not exist on run #${lookupParams.runId}`);
          this.setState({
            overallState: NO_WEIGHT_SHOWING_TANK_INFO,
            weightScalesPickup: null
          });
        }
      } else if (!tankInfo.runs[0].isComplete) {
        this.props.dispatch(push(`${BASE_URL}/runs/${this.getRunUrl(tankInfo.runs[0].id)}/locations/${tankInfo.currentTankLocationId}`));
      } else {
        this.setState({
          overallState: NO_WEIGHT_SHOWING_TANK_INFO,
          weightScalesPickup: null
        });
      }
    }
  }

  getTankInfo(tankId) {
    toastr.success(`Scanned tank #${tankId} - looking up information....`);

    let {userLocation} = this.props;
    let {lookupParams} = this.state;
    let latitude = userLocation.coords ? userLocation.coords.latitude : null;
    let longitude = userLocation.coords ? userLocation.coords.longitude : null;

    apiRequest(`/api/tanks?id=${tankId}&runId=${lookupParams.runId}&pickupId=${lookupParams.pickupId}&latitude=${latitude}&longitude=${longitude}`)
      .then(x => {
        if(x.data && x.data.notFound){
          toastr.error(`Tank #${tankId} information NOT found`);
          this.setState({tankInfo: null, canScan: true, status: null}, this.onTankInfoReceived);
        }
        else {
          toastr.success(`Tank #${tankId} information found`);
          this.setState({tankInfo: x.data, status: null}, this.onTankInfoReceived);
        }
      });
  }

  onError(data){
    console.log(data);
  }

  handleAddPickup(e, runId, existsOnRun) {
    e.preventDefault();

    let {tankInfo} = this.state;
    let {weightScales} = this.props;

    toastr.info(`Adding tank #${tankInfo.id} to run #${runId}`);   
    
    apiPost(`/api/runs/addlocationtorun?id=${runId}&locationId=${tankInfo.currentTankLocationId}`)
      .then(x => {
        if (x.data) {
          toastr.success(`Added tank #${tankInfo.id} to run #${runId}`);          
          this.props.dispatch(loadRun(runId));
          
          if(weightScales.connected) {            
            let run = x.data;
            let pickupTank = flatten(run.pickups.map(x => x.pickupTanks)).find(y => y.tankID === tankInfo.id);

            if (!pickupTank) {
              toastr.error('Unable to find tank in run');
            } else {
              this.setState({
                weightScalesPickup: {
                  pickupTankId: pickupTank.id
                }
              }, () => {
                this.startPickupWeight();
              });
            }
          } else {
            this.props.dispatch(push(`${BASE_URL}/runs/${this.getRunUrl(runId)}/locations/${tankInfo.currentTankLocationId}/${tankInfo.id}`));
          }
        } else {
          toastr.error(`Unable to add tank #${tankInfo.id} to run #${runId}`);
          console.log(x);
        }
      });
  }

  getRunUrl(runId){
    // if the runId is in the drivers runs, then use the drivers url, otherwise use the search url
    let {driverRuns} = this.props;
    
    let driverRun = driverRuns.items.find(x => x.id === parseInt(runId));
    
    //console.log(driverRun, lookupParams.runId, driverRuns);
    let preFix = IsNullOrUndefined(driverRun) ? "search" : "driver";
    
    return `${preFix}/${runId}`;
  }

  
  getLatestPickupWeight() {
    this.setState({tankInfo: null}, () => {
      apiRequest('/api/pickuptanks/weightscales/latest')
          .then(x => {
            if (x.data) {
              if (x.data.latest) {
                this.setState({
                  currentWeightScalePickup: {...x.data.latest},
                  overallState: STATE_WEIGHT_IN_PROGRESS,
                  lookupParams: {
                    runId: x.data.latest.runId,
                    pickupId: x.data.latest.pickupId,
                    pickupTankId: x.data.latest.pickupTankId,
                  }
                }, () => {
                  if (this.state.currentWeightScalePickup) {
                    this.getTankInfo(this.state.currentWeightScalePickup.tankId);
                  }
                });
              } else {
                this.setState({
                  currentWeightScalePickup: null,
                  overallState: STATE_CAN_BEGIN_SCAN,
                });
              }
            } else {
              toastr.error(`While fetching latest weight scale record`);
              console.log(x);
            }
          });
    });
  }
  
  startPickupWeight() {
    let {weightScalesPickup} = this.state;
    let {weightScales} = this.props;

    apiPost(`/api/pickuptanks/weightscales/start`, {
      ...weightScalesPickup,
      startRawWeight: weightScales.currentRawWeight
    })
        .then(x => {
          if (x.data) {
            this.setState({
              currentWeightScalePickup: {...x.data},
              overallState: STATE_WEIGHT_IN_PROGRESS
            });
          } else {
            toastr.error(`Recording current weight`);
            console.log(x);
          }
        });
  }

  getNetLitres(){
    let {currentWeightScalePickup} = this.state;
    let {weightScales} = this.props;
    
    return currentWeightScalePickup && weightScales ? Math.ceil((weightScales.currentRawWeight - currentWeightScalePickup.startRawWeight) * KG_L_CONVERSION) : 0;
  }
  
  beginEndPickupWeight() {
    if(this.getNetLitres() < 0){
      toastr.error(`Net litres is less than zero!`);
    } else {
      this.setState({overallState: STATE_WEIGHT_ENDING});  
    }
  }
  
  endPickupWeight() {
    let {currentWeightScalePickup, tankInfo} = this.state;
    let {weightScales, userLocation} = this.props;
    let latitude = userLocation.coords ? userLocation.coords.latitude : null;
    let longitude = userLocation.coords ? userLocation.coords.longitude : null;

    apiPost(`/api/pickuptanks/weightscales/end`, {
      ...currentWeightScalePickup,
      endRawWeight: weightScales.currentRawWeight,
      latitude,
      longitude,
      netLitres: this.getNetLitres(),
    })
        .then(x => {
          if (x.data) {
            let {runId} = x.data;
            let {tankInfo} = this.state;

            this.setState({currentWeightScalePickup: null, overallState: STATE_CAN_BEGIN_SCAN}, () => {
              this.props.dispatch(loadRun(runId));
              this.props.dispatch(push(`${BASE_URL}/runs/${this.getRunUrl(runId)}/locations/${tankInfo.currentTankLocationId}`));
            });
          } else {
            toastr.error(`Completing the pickup`);
            console.log(x);
          }
        });
  }

  beginCancel(){
    let {currentWeightScalePickup, tankInfo} = this.state;
    let {weightScales, userLocation} = this.props;
    
    if(weightScales.currentRawWeight - currentWeightScalePickup.startRawWeight !== 0 && isNullEmptyOrWhitespace(currentWeightScalePickup.description)) {
      this.setState({overallState: STATE_WEIGHT_CANCELLING_NEED_REASON});
    } else {
      this.completeCancel();
    }
  }
  
  completeCancel(){
    let {currentWeightScalePickup, tankInfo} = this.state;
    let {weightScales, userLocation} = this.props;
    let latitude = userLocation.coords ? userLocation.coords.latitude : null;
    let longitude = userLocation.coords ? userLocation.coords.longitude : null;
    
    if(weightScales.currentRawWeight - currentWeightScalePickup.startRawWeight !== 0 && isNullEmptyOrWhitespace(currentWeightScalePickup.description)){
      toastr.error(`Please explain the difference in weight!`);
    } else {
      apiPost(`/api/pickuptanks/weightscales/end`, {
        ...currentWeightScalePickup,
        endRawWeight: null,
        latitude,
        longitude,
        netLitres: null,
        isCancelled: true,
      }).then(x => {
            if (x.data) {
              let {runId} = x.data;
              let {tankInfo} = this.state;
              this.setState({currentWeightScalePickup: null, overallState: STATE_CAN_BEGIN_SCAN}, () => {
                this.props.dispatch(push(`${BASE_URL}/runs/${this.getRunUrl(runId)}/locations/${tankInfo.currentTankLocationId}`));
              });
            } else {
              toastr.error(`Cancelling the pickup`);
              console.log(x);
            }
          });
    }
  }

  componentDidMount(){
    this.getLatestPickupWeight();    
    window.scrollTo(0, 0);
  }
  
  componentDidUpdate(prevProps, prevState, snapshot) {
    if(JSON.stringify(prevProps.lookupParams) !== JSON.stringify(this.props.lookupParams)){
      this.setState({lookupParams: {...this.props.lookupParams}}, this.getLatestPickupWeight);
    }
  }

  render(){
    let {scanResult, status, canScan, tankInfo, autoNavigateToRun, 
      lookupParams, currentWeightScalePickup, overallState} = this.state;
    let {weightScales, account, truckData} = this.props;
    let showScanner = ((overallState === STATE_CAN_BEGIN_SCAN || overallState === STATE_WEIGHT_ENDING) && canScan);
    let netLitres = this.getNetLitres();
    
    return (<div>
      <div className="row">
        <div className="col-md-6">
          {showScanner &&
          <Aux>
            {/*<input onChange={e => this.setState({tankId: e.target.value})}/>
            <button onClick={() => this.getTankInfo(parseInt(this.state.tankId))}>Lookup</button>*/}
            
            { overallState === STATE_WEIGHT_ENDING && <div className={"alert alert-info mt-2"}>Please scan the same tank you began the pickup with to end</div> }
            
            <QrReader
                delay={300}
                onError={this.onError}
                onScan={this.onScan}
                style={{width: '100%'}}
            />
          </Aux> }
        </div>
        <div className="col-md-6">
          <ScaleStatusView weightScales={weightScales} truckData={truckData} />
          
          {overallState === STATE_CAN_BEGIN_SCAN && canScan && !status && <div className={'alert alert-success'}>Ready to scan!</div> }
          {canScan && status && <div className={'alert alert-warning'}>{status}</div> }
          {scanResult && <div className={'alert alert-success'}>Scan successful: {scanResult}</div>}
          {scanResult && !tankInfo && <div className={'alert alert-danger'}>Scan succeeded, however no tank info found</div>}
          {!canScan && status && <div className={'alert alert-warning'}>{status}</div> }          

          { overallState === STATE_CAN_BEGIN_SCAN && <div>
            <input type={'checkbox'} checked={autoNavigateToRun} onChange={(ev) => this.setState({autoNavigateToRun: ev.target.checked})} /> Navigate to pickup on successful scan
          </div> }
          
          {
            (!IsNullOrUndefined(tankInfo)) &&
            <Aux>
              { currentWeightScalePickup === null && <div className="row mt-1">
                <div className="col-md-4">
                  <Button color={'info'} className={"mb-1"} onClick={this.getLatestPickupWeight}>Scan again</Button>
                </div>
              </div> }
              <div className="row">
                <div className="col-md-4">
                  <b>Status</b>
                </div>
                <div className={`col-md-8 text-white ${tankInfo.isInactive ? 'bg-danger' : 'bg-success'}`}>
                  {tankInfo.isInactive ? "Inactive" : "Active"}
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <b>Capacity</b>
                </div>
                <div className="col-md-8">
                  {tankInfo.capacityLitres}
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <b>Name</b>
                </div>
                <div className="col-md-8">
                  {tankInfo.name}
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <b>Location</b>
                </div>
                <div className="col-md-8">
                  {tankInfo.currentTankLocationName}
                </div>
              </div>
              { (tankInfo.latitude !== null && tankInfo.longitude !== null) &&
              <div className="row">
                <div className="col-md-4">
                  <b>Scan location</b>
                </div>
                <div className="col-md-8">
                  <a href={`http://maps.google.com/maps?&z=21&q=${tankInfo.latitude}+${tankInfo.longitude}`} target={'_blank'}>{`${tankInfo.latitude}, ${tankInfo.longitude}`}</a>
                </div>
              </div> }

              { overallState === STATE_WEIGHT_CAN_BEGIN_FROM_REF && <div className="row mb-2">
                <div className="col-md-12">
                  <Button color={'info'} onClick={this.startPickupWeight}>Begin scale pickup for current run</Button>
                </div>
              </div> }
              
              
              {tankInfo.isInactive ? (<div className="row">
                    <div className="col-md-12">
                      <div className="p-3 mb-2 bg-danger text-white">Tank is Inactive and cannot be added to a run</div>
                    </div>
                  </div>) :
                  (overallState === STATE_WEIGHT_CAN_BEGIN_POTENTIAL || !weightScales.connected) && (<Aux>
                    <div className="row mt-2 mb-2">
                      <div className="col-md-12">
                        <b>{allowUserWithRoles(account, [ROLE_SuperUser, ROLE_OfficeUser, ROLE_SalesManager]) ? 'All Pending Runs (up to 3 months old)' : 'Current Driver Runs'}</b>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <ul className="list-group"> {tankInfo.potentialDriverRuns.length === 0 ? (<li
                            className={`list-group-item list-group-item-warning`}>Current driver has no other
                          potential
                          pending runs for today</li>) : tankInfo.potentialDriverRuns.map(r => (
                            <li
                                className={`list-group-item list-group-item-warning`}
                                key={r.runId}>
                              <Button color={'info'}
                                      onClick={(e) => this.handleAddPickup(e, r.runId, r.existsOnRun)}
                                      style={{marginRight: '10px'}}>Pickup{weightScales.connected ? ' from scales':''}</Button>
                              <a href={`${BASE_URL}/runs/${this.getRunUrl(r.runId)}`}
                                 target={'_blank'}>{moment(r.runStartDateTime).format(SHORT_DATE_FORMAT)} -
                                #{r.runId} - {r.driverFirstName}</a>
                            </li>
                        ))}

                        </ul>
                      </div>
                    </div>
                  </Aux>)
              }              
            </Aux>
          }

          { (overallState === STATE_WEIGHT_IN_PROGRESS || overallState === STATE_WEIGHT_ENDING_WRONG_TANK || overallState === STATE_WEIGHT_ENDING || overallState===STATE_WEIGHT_CANCELLING_NEED_REASON) &&
            <Aux>
              <div className="row mt-2">
                <div className="col-md-12">
                  <ul>
                    <li>
                      You are currently picking up <b>Tank #{currentWeightScalePickup.tankId}</b></li>
                    <li>
                      Started at {moment(currentWeightScalePickup.startPickupDateTime).format(LONG_DATE_FORMAT)} by {currentWeightScalePickup.startByUserName}
                    </li>
                    <li>
                      Weight at start: <b>{currentWeightScalePickup.startRawWeight} Kg</b>
                    </li>
                    <li>
                      Current weight: <b>{weightScales.currentRawWeight} Kg</b>
                    </li>
                    <li>
                      Net collected: <b>{netLitres} L</b>
                    </li>
                  </ul>
                </div>
              </div>
              {overallState !== STATE_WEIGHT_CANCELLING_NEED_REASON && 
              <div className="row mb-2">
                <div className="col-md-12">
                  {overallState=== STATE_WEIGHT_ENDING_WRONG_TANK && <div className={'alert alert-danger'}>This not the same tank that was being picked up!</div> }
                  {overallState !== STATE_WEIGHT_ENDING && <Button color={'warning'} onClick={this.beginEndPickupWeight}>End Pickup</Button> }
                  <Button color={'danger'} className={'ml-1'} onClick={this.beginCancel}>Cancel Pickup</Button>
                </div>
              </div>}
              { overallState === STATE_WEIGHT_CANCELLING_NEED_REASON &&  
              <Aux>
                <div className={'alert alert-danger'}>There is a difference in weight, please explain before cancelling</div>
                <div className="row mb-2">
                  <div className="col-md-12">                    
                    <textarea className={"form-control"} rows="6" cols="20" onChange={(e) => {
                      this.setState({
                        currentWeightScalePickup: {
                          ...currentWeightScalePickup,
                          description: e.target.value
                        }
                      });
                    }}/>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-md-12">
                    <Button color={'danger'} onClick={this.completeCancel}>Ok</Button>
                    <Button color={'info'} className={'ml-1'} onClick={() => this.setState({
                      overallState: STATE_WEIGHT_IN_PROGRESS,
                      currentWeightScalePickup: {
                        ...currentWeightScalePickup, 
                        description: null
                      }
                    })}>Cancel</Button>
                  </div>
                </div>
              </Aux>}
            </Aux>
          }

          {tankInfo && tankInfo.runs.length > 0 && allowUserWithRoles(account, [ROLE_SuperUser, ROLE_OfficeUser, ROLE_SalesManager]) &&
          <Aux>
            <div className="row mt-2 mb-2">
              <div className="col-md-12">
                <b>Run History</b>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <ul className="list-group"> {tankInfo.runs.map(run => (
                    <li
                        className={`list-group-item list-group-item-${run.isComplete ? 'success' : run.isPending ? 'warning' : 'danger'}`}
                        key={run.id}>
                      <a href={`${BASE_URL}/runs/${this.getRunUrl(run.id)}/locations/${tankInfo.currentTankLocationId}`}
                         target={'_blank'}>
                        {moment(run.timeStart).format(SHORT_DATE_FORMAT)} - #{run.id}</a>
                    </li>
                ))}
                </ul>
              </div>
            </div>
          </Aux>
          }
        </div>
      </div>
    </div>);
  }
}

QrLookupRunLocationPage.propTypes = {
  account: PropTypes.object,
  driverRuns: PropTypes.object.isRequired,
  weightScales: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps){
  let lookupParams = querySearch(ownProps.location.search);

  return {
    lookupParams: lookupParams === null ? {...defaultLookupParams} : lookupParams,
    userLocation: state.location,
    account: state.account,
    driverRuns: state.driverRuns,
    weightScales: {
      connected: state.truckData.weight.connected,
      currentWeight: state.truckData.weight.currentWeight,
      currentRawWeight: state.truckData.weight.currentRawWeight,
      truckNumberPlate: state.truckData.truckNumberPlate,
      errorReason: state.truckData.errorReason,
    },
    truckData: state.truckData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QrLookupRunLocationPage));
